module.exports = __webpack_public_path__ + "components/country-flag/static/dz-d972540ff740cf274268467892fb1bfd.svg";